export class BackButton {

	constructor(elem) {
		this.elem = elem;
		this.addEventListeners();
	}

	addEventListeners() {
		this.elem.addEventListener('click', (event) => {
			this.handleBack(event)
		});
	}

	handleBack(event) {
		event.preventDefault();

		const ref = document.referrer;
		const target = event.currentTarget;
		// Targethref is the href from the back button
		this.targetHref = target.getAttribute('href');

		if (ref) {
			this.handleRef(ref);
		} else {
			window.location.href = this.targetHref;
		}
	}

	handleRef(ref) {
		// Get current host
		const curHost = window.location.host + window.location.pathname.split(/\/(?=.)/)[1];

		// Create a parser to parse the ref to an <a> tag. With that we can get the host, hostname, pathname, etc.
		let parser = document.createElement('a');
		parser.href = ref;
		let parserHost = parser.host + parser.pathname.split(/\/(?=.)/)[1];

		if (curHost.includes(parserHost)) {
			// If the current URL contains a part of the previous URL, use back button
			window.history.back();
		} else {
			// Else Go to overviewpage
			window.location.href = this.targetHref;
		}
	}

	static getSelector() {
		return '[data-backbutton]';
	}
}

